import {useQuery} from '@apollo/react-hooks';

import {safelyGetGraphQLErrorMessage} from 'nutshell-core/utils/graphql-errors';

import type {GetCompetitorIqWebsites as GetCompetitorIqWebsitesQuery} from 'nutshell-graphql-types';

import GET_WEBSITES from '../queries/get-competitor-iq-websites.graphql';

export const useGetCompetitorIqWebsites = () => {
    const {
        data,
        error,
        loading: isLoading,
    } = useQuery<GetCompetitorIqWebsitesQuery, Record<any, any>>(GET_WEBSITES, {});

    const competitorIqSettings = data ? data.competitorIqSettings : null;

    return {
        predictedWebsite: competitorIqSettings ? competitorIqSettings.predictedWebsite : '',
        website: competitorIqSettings ? competitorIqSettings.website : undefined,
        competitors: competitorIqSettings ? competitorIqSettings.competitors : [],
        // @ts-expect-error
        error: safelyGetGraphQLErrorMessage(error),
        isLoading,
    };
};
